import { isDevelopmentEnvironment, isStagingEnvironment } from '@alexis/helpers/environment';
import { gtmTrack } from '@alexis/helpers/gtm';
import { useEffect, useState } from 'react';

import {
  GTM_AUTH_PRODUCTION,
  GTM_AUTH_STAGING,
  GTM_ID,
  GTM_PREVIEW_PRODUCTION,
  GTM_PREVIEW_STAGING,
} from '@constants/general';

const hostname = window.location.hostname;
const gtmAuth: string =
  isDevelopmentEnvironment(hostname) || isStagingEnvironment(hostname)
    ? GTM_AUTH_STAGING
    : GTM_AUTH_PRODUCTION;

const gtmPreview: string =
  isDevelopmentEnvironment(hostname) || isStagingEnvironment(hostname)
    ? GTM_PREVIEW_STAGING
    : GTM_PREVIEW_PRODUCTION;

interface GTMTrackOptions {
  trackOnce?: boolean;
}

const useGTMTracker = <T>(data: T | null, options?: GTMTrackOptions) => {
  const [eventFired, setEventFired] = useState<boolean>(false);

  const gtmTrackOptions: GTMTrackOptions = {
    trackOnce: true,
    ...options,
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    if (gtmTrackOptions.trackOnce) {
      if (eventFired) {
        return;
      }

      gtmTrack(GTM_ID, gtmAuth, gtmPreview, data);
      setEventFired(true);
    } else {
      gtmTrack(GTM_ID, gtmAuth, gtmPreview, data);
    }
  }, [data, eventFired, gtmTrackOptions.trackOnce]);

  return eventFired;
};

export default useGTMTracker;
